// extracted by mini-css-extract-plugin
export default {"Dropzone":"Dropzone_Dropzone__b2pHX","Highlight":"Dropzone_Highlight__HYWhX","Icon":"Dropzone_Icon__6KG4v","FileInput":"Dropzone_FileInput__O3zQT"};